import React, { useState } from "react";
import "./NavbarStyles.css";
import { Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from "./logo.png";
import { motion } from "framer-motion";

const Navbar = () => {
  const [mtnx, setMtnx] = useState(false);
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  const [color, setColor] = useState(false);
  const changeColor = () => {
    if (window.scrollY >= 100) {
      setColor(true);
    } else {
      setColor(false);
    }
  };
  window.addEventListener("scroll", changeColor);

  return (
    <div className={color ? "header header-bg" : "header"}>
      <Link to="/">
        <motion.img
          src={logo}
          className="logo"
          alt={"portfolio"}
          animate={{
            rotate: mtnx ? 360 : 0,
          }}
          transition={{
            type: "spring",
            duration: 2,
            damping: 8,
            stiffness: 50,
          }}
          onClick={() => setMtnx(!mtnx)}
        ></motion.img>
      </Link>

      <ul className={click ? "nav-menu active" : "nav-menu"}>
        <li>
          <Link to="/">
            <h1>Home</h1>
          </Link>
        </li>
        <li>
          <Link to="/Project">
            <h1>Project</h1>
          </Link>
        </li>
        <li>
          <Link to="/About">
            <h1>About</h1>
          </Link>
        </li>
        <li>
          <Link to="/Contact">
            <h1>Contact</h1>
          </Link>
        </li>
      </ul>
      <div className="hamburger" onClick={handleClick}>
        {click ? (
          <FaTimes size={20} style={{ color: "white" }} />
        ) : (
          <FaBars size={20} style={{ color: "white" }} />
        )}
      </div>
    </div>
  );
};

export default Navbar;
